import React, { useState } from 'react';
import { toast } from 'sonner';
import api from '../../api';
import { ActionDialog, Field, inputCls, primaryBtn } from './ActionDialog';

// HCPCS place-of-service codes used on home health claims
const TYPES = ['Q5001 - Patient\'s home / residence', 'Q5002 - Assisted living facility', 'Q5009 - Place not otherwise specified (e.g. group home, board & care)'];

export const ServiceLocationDialog = ({ patient, onClose, onSaved }) => {
  const [v, setV] = useState({
    serviceLocationType: patient.serviceLocationType || TYPES[0],
    serviceLocationName: patient.serviceLocationName || '',
    serviceLocationAddress: patient.serviceLocationAddress || [patient.address, patient.city, patient.state, patient.zipCode].filter(Boolean).join(', '),
  });
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try { await api.put(`/patients/${patient.id}`, v); toast.success('Service location saved'); onSaved(v); onClose(); }
    catch { toast.error('Could not save service location'); }
    finally { setSaving(false); }
  };
  return (
    <ActionDialog title="Service Provided Location" onClose={onClose} testid="service-location-dialog">
      <div className="space-y-3">
        <Field label="Location type (claim code)">
          <select className={inputCls} value={v.serviceLocationType} onChange={e => setV({ ...v, serviceLocationType: e.target.value })} data-testid="service-location-type">
            {TYPES.map(t => <option key={t}>{t}</option>)}
          </select>
        </Field>
        <Field label="Facility / residence name (if not home)"><input className={inputCls} value={v.serviceLocationName} onChange={e => setV({ ...v, serviceLocationName: e.target.value })} data-testid="service-location-name" /></Field>
        <Field label="Address where care is given"><input className={inputCls} value={v.serviceLocationAddress} onChange={e => setV({ ...v, serviceLocationAddress: e.target.value })} data-testid="service-location-address" /></Field>
        <div className="flex justify-end"><button className={primaryBtn} onClick={save} disabled={saving} data-testid="service-location-save">{saving ? 'Saving…' : 'Save'}</button></div>
      </div>
    </ActionDialog>
  );
};
